export const isArray = (val: unknown) => {
  return Array.isArray(val)
}

export const isUndefined = (val: unknown) => {
  return val === undefined
}
